var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50077 8.88517C1.50077 12.9731 4.81471 16.2871 8.90266 16.2871C12.9906 16.2871 16.3045 12.9731 16.3045 8.88517C16.3045 4.79722 12.9906 1.48328 8.90266 1.48328C4.81471 1.48328 1.50077 4.79722 1.50077 8.88517ZM8.90266 17.556C4.11392 17.556 0.231873 13.6739 0.231873 8.88517C0.231873 4.09643 4.11392 0.214386 8.90266 0.214386C13.6914 0.214386 17.5734 4.09643 17.5734 8.88517C17.5734 11.0512 16.7792 13.0317 15.4661 14.5514L18.2335 17.3188C18.4813 17.5666 18.4813 17.9683 18.2335 18.2161C17.9858 18.4638 17.5841 18.4638 17.3363 18.2161L14.5689 15.4486C13.0492 16.7617 11.0687 17.556 8.90266 17.556Z",
    fill: "#615E83"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.3457bc8ea68d60a2abd48474554e260d.svg";
export { ForwardRef as ReactComponent };